<template>
  <p class="text-gray-500 text-sm italic mb-5">
    <span class="text-red-500">*</span> -
    {{ lang === "mn" ? "Заавал бөглөх" : "Must be filled" }}
  </p>

  <div class="flex max-sm:flex-col gap-5 md:gap-10 w-full">
    <div class="w-full">
      <label for="nameMn"
        >{{ lang === "mn" ? "Нэр /монголоор/:" : "Name by Mongolian:"
        }}<span class="text-red-500">*</span></label
      >
      <input
        id="nameMn"
        name="nameMn"
        type="text"
        placeholder="Нэр"
        class="w-full p-2 border"
        :class="errors.nameMn ? 'border-red-500' : ''"
        v-model="form.nameMn"
        @input="errors.nameMn = false"
      />
      <p v-if="errors.nameMn" class="text-red-500 text-sm mt-1">
        {{
          lang === "mn"
            ? "Энэ талбарыг бөглөнө үү."
            : "Please fill out this field."
        }}
      </p>
    </div>

    <div class="w-full">
      <label for="nameEn"
        >{{ lang === "mn" ? "Нэр /англиар/:" : "Name by English:"
        }}<span class="text-red-500">*</span></label
      >
      <input
        id="nameEn"
        name="nameEn"
        type="text"
        placeholder="Name"
        class="w-full p-2 border"
        :class="errors.nameEn ? 'border-red-500' : ''"
        v-model="form.nameEn"
        @input="errors.nameEn = false"
      />
      <p v-if="errors.nameEn" class="text-red-500 text-sm mt-1">
        {{
          lang === "mn"
            ? "Энэ талбарыг бөглөнө үү."
            : "Please fill out this field."
        }}
      </p>
    </div>
  </div>

  <div class="flex max-sm:flex-col gap-5 md:gap-10 w-full my-5">
    <div class="w-full">
      <label for="professionMn"
        >{{
          lang === "mn" ? "Мэргэжил /монголоор/:" : "Profession by Mongolian:"
        }}<span class="text-red-500">*</span></label
      >
      <input
        id="professionMn"
        name="professionMn"
        type="text"
        placeholder="Мэргэжил"
        class="w-full p-2 border"
        :class="errors.professionMn ? 'border-red-500' : ''"
        v-model="form.professionMn"
        @input="errors.professionMn = false"
      />
      <p v-if="errors.professionMn" class="text-red-500 text-sm mt-1">
        {{
          lang === "mn"
            ? "Энэ талбарыг бөглөнө үү."
            : "Please fill out this field."
        }}
      </p>
    </div>

    <div class="w-full">
      <label for="professionEn"
        >{{ lang === "mn" ? "Мэргэжил /англиар/:" : "Profession by English:"
        }}<span class="text-red-500">*</span></label
      >
      <input
        id="professionEn"
        name="professionEn"
        type="text"
        placeholder="Profession"
        class="w-full p-2 border"
        :class="errors.professionEn ? 'border-red-500' : ''"
        v-model="form.professionEn"
        @input="errors.professionEn = false"
      />
      <p v-if="errors.professionEn" class="text-red-500 text-sm mt-1">
        {{
          lang === "mn"
            ? "Энэ талбарыг бөглөнө үү."
            : "Please fill out this field."
        }}
      </p>
    </div>
  </div>

  <div class="flex max-sm:flex-col gap-5 md:gap-10 w-full my-5">
    <div class="flex flex-col w-full">
      <label for="phone"
        >Утасны дугаар:<span class="text-red-500">*</span></label
      >
      <input
        id="phone"
        name="phone"
        type="text"
        placeholder="Утас"
        class="w-full p-2 border"
        :class="errors.phone ? 'border-red-500' : ''"
        v-model="form.phone"
        @input="errors.phone = false"
      />
      <p v-if="errors.phone" class="text-red-500 text-sm mt-1">
        {{
          lang === "mn"
            ? "Энэ талбарыг бөглөнө үү."
            : "Please fill out this field."
        }}
      </p>
    </div>

    <div class="w-full"></div>
  </div>

  <label for="adviceMn">{{
    lang === "mn"
      ? "Зөвлөгөөний хүрээ /монголоор/:"
      : "Advice Range by Mongolian:"
  }}</label>
  <textarea
    id="adviceMn"
    name="adviceMn"
    type="text"
    rows="4"
    placeholder="Зөвлөгөө"
    class="w-full p-2 border mb-5"
    v-model="form.adviceMn"
  >
  </textarea>

  <label for="adviceEn" class="my-5">{{
    lang === "mn" ? "Зөвлөгөөний хүрээ /англиар/:" : "Advice Range by English:"
  }}</label>
  <textarea
    id="adviceEn"
    name="adviceEn"
    type="text"
    rows="4"
    placeholder="Advice Range"
    class="w-full p-2 border mb-20"
    v-model="form.adviceEn"
  >
  </textarea>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

export default {
  name: "YellowCompanyRegistration",
  props: {
    consultant: Object,
  },
  setup(props, { expose }) {
    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);

    const form = ref({
      nameMn: "",
      nameEn: "",
      professionMn: "",
      professionEn: "",
      phone: "",
      adviceMn: "",
      adviceEn: "",
    });

    onMounted(() => {
      if (props.consultant) {
        form.value = {
          nameMn: props.consultant.nameMn,
          nameEn: props.consultant.nameEn,
          professionMn: props.consultant.professionMn,
          professionEn: props.consultant.professionEn,
          phone: props.consultant.phone,
          adviceMn: props.consultant.adviceMn,
          adviceEn: props.consultant.adviceEn,
        };
      }
    });

    const errors = ref({
      nameMn: false,
      nameEn: false,
      professionMn: false,
      professionEn: false,
      phone: false,
      adviceMn: false,
      adviceEn: false,
    });

    const validateForm = () => {
      let valid = true;
      const requiredFields = [
        "nameMn",
        "nameEn",
        "professionMn",
        "professionEn",
        "phone",
      ];

      Object.keys(errors.value).forEach((key) => {
        errors.value[key] = false;
      });

      requiredFields.forEach((field) => {
        if (!form.value[field]) {
          errors.value[field] = true;
          valid = false;
        } else {
          errors.value[field] = false;
        }
      });

      return valid;
    };

    expose({ validateForm, form });

    return {
      lang,
      form,
      errors,
    };
  },
};
</script>
